import { colors, fontSizes } from "@hubrise/react-components"
import styled from "styled-components"

export const Section = styled.div`
  padding: 1rem 0;
`

export const SectionTitle = styled.div`
  font-size: ${fontSizes._12};
  color: ${colors.textMedium};
  font-weight: 500;
  margin-bottom: 0.5rem;
`

export const Hint = styled.div`
  display: flex;
  justify-content: end;
  font-size: ${fontSizes._12};
  color: ${colors.textLight};
  font-style: italic;
  margin-top: 0.5rem;
`

export const Rows = styled.div`
  padding: 0.125rem 0;
  border-top: 1px solid ${colors.borderLight};
  border-bottom: 1px solid ${colors.borderLight};
`

export const Row = styled.div<{ $isParent?: boolean }>`
  padding: 0.125rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const RowSeparator = styled.div`
  height: 1px;
  background-color: ${colors.borderLight};
  margin: 0.125rem 0;
`

export const Label = styled.div<{ $indent?: boolean }>`
  flex: 1;
  font-size: ${fontSizes._12};
  color: ${colors.textMedium};
  padding-left: ${({ $indent }) => ($indent === true ? "1.25rem" : "0")};
`
